/** @format */
import { useState } from 'react'
import { _$, Message } from 'kpc-react'
import { handleDateFormat, IMonitorGraphData } from './constants'
import API from 'src/api/ApiDashboard'
import moment from 'moment'
import { request, keepDecimal, handleUnit } from 'src/utils'
import { useAsyncFn } from 'react-use'
// eslint-disable-next-line max-len
import { aggregator_menu } from 'src/containers/MonitorDashboard/Customboard/EditGraphMetricFormItem'
// import _ from 'lodash'
const getMetricStatisticsBatch = (graph?: IMonitorGraphData) => {
  const [chartData, setChartData] = useState<any>()
  const handleGraph = (start, end, delay, newGraph: IMonitorGraphData) => {
    const cloneMetrics = []
    let lineCount = 0
    newGraph.metrics.forEach((metric, index) => {
      const {
        graphMetricId,
        productType,
        instances,
        metricKey,
        metricName,
        metricTags,
        units,
        aggregator,
        resourceAggregator
      } = metric
      const m = {
        GraphMetricId: graphMetricId || 0 - index,
        ProductType: productType,
        MetricKey: metricKey,
        MetricName: metricName,
        Delay: delay,
        Units: units,
        Instances: [],
        metricTags: metricTags || [],
        Aggregator: aggregator || 'max',
        resourceAggregator: resourceAggregator || ''
      }
      if (instances?.length) {
        instances.forEach(instance => {
          lineCount += 1
          m.Instances.push(instance.instanceId)
        })
      }
      cloneMetrics.push(m)
    })
    return {
      DashboardId: newGraph?.dashboardId,
      StartTime: start,
      EndTime: end,
      Period: delay,
      Metrics: cloneMetrics,
      LineCount: lineCount
    }
  }
  // 获取图表数据
  const getDashboardChart = async (
    startTime: number,
    endTime: number,
    delay,
    newGraph?: IMonitorGraphData,
    dataFormat?: string,
    tip = true,
    noloading = false
  ) => {
    const graphData = newGraph || graph
    const firstMetric = graphData?.metrics[0]
    // 是否有数据
    if (!firstMetric?.metricKey || !firstMetric?.instances?.length || !delay) {
      setChartData(undefined)
      return Promise.resolve(undefined)
    }
    const params = handleGraph(startTime, endTime, delay, graphData)
    // 实例是否超过100条
    if (params.LineCount > 1000) {
      tip && Message.error(_$('单个视图最多可添加1000条监控数据'))
      setChartData({})
      return
    }
    const result = await fetch(params, startTime, endTime, delay, dataFormat, noloading)
    setChartData(result)
    return result
  }
  const [{ loading }, fetch] = useAsyncFn(
    async (params, startTime, endTime, delay, dataFormat, noloading) => {
      const result = await request(API.DescribeDashboardMetricsData, {
        method: 'POST',
        data: params,
        noloading
      })
      if (result?.code === 'Success') {
        const { data } = result.data
        let findLine
        data.some(item => {
          findLine = item.series.find(item => item?.data?.length)
          if (findLine) {
            return true
          } else {
            return false
          }
        })
        const formatData = handleDateFormat([startTime, endTime], delay)
        if (!formatData) {
          return Promise.resolve(undefined)
        }
        // x轴时间刻度
        let xData = []
        // 如果查到有返回数据的话，使用返回数据中的时间戳
        if (findLine?.data?.length) {
          xData = findLine.data.map(({ timestamp }) => timestamp)
        } else {
          // 如果一条数据都没有返回，前端自己计算出x轴时间刻度
          let curTime = startTime / 1000
          while (curTime < endTime / 1000) {
            curTime += delay
            xData.push(curTime)
          }
          // xData = curArr.map(cur => moment(cur).format(dataFormat || formatData))
        }
        // series数据
        const seriesData = []
        data.forEach(({ resourceAggregator, series, units, metricName }, index) => {
          if (!resourceAggregator) {
            const seriesMap = series.map(({ legend, instanceId, data }) => {
              const findLegend = seriesData.find(({ name }) => name.split('===')[0] === legend)
              const lastInstance = instanceId.substr(-4)
              const name = findLegend ? `${legend}-${lastInstance}` : legend
              const seriesObject = {
                name: `${name}===${units || ''}`,
                type: 'line',
                data: data?.length
                  ? data.map(({ value }) =>
                      value && value !== 'null' ? keepDecimal(value) : undefined
                    )
                  : new Array(xData.length),
                symbol: 'circle',
                symbolSize: 4,
                smooth: true,
                lineStyle: {
                  width: 2
                },
                smpling: 'lttb'
              }
              return seriesObject
            })
            seriesMap?.length && seriesData.push(...seriesMap)
          } else {
            // 聚合值
            const aggData = series.map(({ data }) => {
              return data?.length
                ? data.map(({ value }) =>
                    value && value !== 'null' ? keepDecimal(value) : undefined
                  )
                : new Array(xData.length)
            })
            const concatData = []
            for (let i = 0; i < xData.length; i++) {
              const curData = aggData.map(item => item[i])
              concatData.push(curData)
            }
            const calcData = concatData.map(item => {
              if (item.includes(undefined)) {
                return undefined
              } else {
                if (resourceAggregator === 'max') {
                  return keepDecimal(Math.max.apply(null, item))
                } else if (resourceAggregator === 'min') {
                  return keepDecimal(Math.min.apply(null, item))
                } else if (resourceAggregator === 'average') {
                  return keepDecimal(item.reduce((pre, cur) => (pre += cur), 0) / item.length)
                } else if (resourceAggregator === 'sum') {
                  return keepDecimal(item.reduce((pre, cur) => (pre += cur), 0))
                } else {
                  return undefined
                }
              }
            })
            // name
            // 按照聚合方式计算
            const filterNull = calcData.filter(item => item !== undefined && item !== null)
            let aggValue: any = 0
            if (filterNull?.length) {
              if (resourceAggregator === 'max') {
                aggValue = keepDecimal(Math.max.apply(null, filterNull) || null)
              } else if (resourceAggregator === 'min') {
                aggValue = keepDecimal(Math.min.apply(null, filterNull) || null)
              } else if (resourceAggregator === 'average') {
                aggValue = keepDecimal(
                  filterNull.reduce((pre, cur) => (pre += cur), 0) / filterNull.length || null
                )
              } else if (resourceAggregator === 'sum') {
                aggValue = keepDecimal(filterNull.reduce((pre, cur) => (pre += cur), 0) || null)
              }
            } else {
              aggValue = 'N/A'
            }
            const legend = `${metricName}-${aggregator_menu[resourceAggregator]}:${handleUnit(
              aggValue,
              units || ''
            )}`
            // 查询重复名称
            const findLegend = seriesData.filter(({ name }) => {
              const namesplit = name.split('===')[0]
              return namesplit === legend
            })
            const name = findLegend?.length ? `${legend}-${findLegend?.length + 1}` : legend
            const seriesObject = {
              name: `${name}===${units || ''}`,
              type: 'line',
              data: calcData,
              smooth: true,
              symbol: 'circle',
              symbolSize: 4,
              lineStyle: {
                width: 2
              },
              smpling: 'lttb',
              resourceAggregator
            }
            seriesData.push(seriesObject)
          }
        })
        return Promise.resolve({
          series: seriesData,
          xData: xData.map(cur => moment(cur * 1000).format(dataFormat || formatData)),
          interval: delay,
          lineCount: params.LineCount
        })
      } else {
        return Promise.reject({
          series: [],
          xData: [],
          interval: delay,
          lineCount: params.LineCount
        })
      }
    },
    []
  )

  return {
    getDashboardChart,
    chartData,
    loading
  }
}

export default getMetricStatisticsBatch
